import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/RaioX";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/raio-x")({
  head: () => pageHead({ title: "RaioX | Clara Camille", path: "/raio-x", noindex: true }),
  component: Page,
});
